import React from "react";
import CourtAvailability from "./components/CourtAvailability";
import "./App.css";

function App() {
  return (
    <div className="App">
      <CourtAvailability />
    </div>
  );
}

export default App;
